import { useState } from "react";
import { Reveal } from "@/components/Reveal";
import { siteConfig } from "@/data/siteConfig";

export function GalleryGrid({ filterable = false, limit }) {
  const cats = ["All", ...Array.from(new Set(siteConfig.gallery.map((g) => g.cat)))];
  const [active, setActive] = useState("All");
  let items = active === "All" ? siteConfig.gallery : siteConfig.gallery.filter((g) => g.cat === active);
  if (limit) items = items.slice(0, limit);

  return (
    <div data-testid="gallery-grid">
      {filterable && (
        <div className="mb-8 flex flex-wrap gap-2">
          {cats.map((c) => (
            <button key={c} onClick={() => setActive(c)} data-testid={`gallery-filter-${c.toLowerCase()}`}
              className={`px-4 py-2 text-xs font-semibold uppercase tracking-wider transition-colors duration-200 ${active === c ? "bg-ink text-white" : "bg-white text-ink border border-[#E3E8EF] hover:border-ink"}`}>
              {c}
            </button>
          ))}
        </div>
      )}
      <div className="columns-1 gap-4 sm:columns-2 lg:columns-3 [&>*]:mb-4">
        {items.map((g, i) => (
          <Reveal key={i} delay={(i % 3) * 0.06} className="group relative block overflow-hidden break-inside-avoid border border-[#E3E8EF]">
            <img src={g.src} alt={g.alt} loading="lazy" className={`w-full object-cover transition-transform duration-500 group-hover:scale-105 ${i % 3 === 0 ? "h-72" : i % 2 === 0 ? "h-56" : "h-64"}`} />
            <div className="absolute inset-0 flex items-end bg-gradient-to-t from-ink/80 via-ink/10 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100">
              <span className="p-4 font-display uppercase tracking-wide text-white">{g.cat}</span>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
